export class TuplaRefacturacion
{
  refacturacionFacturaId:string;
  esRefacturacionTotal:boolean;
}
